import { useBaseApiMutation } from "@mutation/baseMutation";

export const useSiteUpdateMutation = (site_uuid) => {
    return useBaseApiMutation({
        method: "PUT",
        endpoint: `/site/${site_uuid}`,
    });
};